export default __webpack_public_path__ + "static/media/Platinum.f50a296b.svg";